export const config = {
    shopifyDirectUrl: 'shopify:admin/api/graphql.json',
};
